import PropTypes from 'prop-types';
import React from 'react';

export const RatchetBracketWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'RATCHET_BRACKET',
    category: 'Exit',
    type: 'Ratchet Bracket',
    domain: 'Profit/Loss',
  };
  const stop = softOrder.stop;
  const priceToBreak = softOrder.priceToBreak;
  const pendingTargets = softOrder.pendingTargets ?? [];

  return <Component details={details} stop={stop} priceToBreak={priceToBreak} pendingTargets={pendingTargets} {...rest} />;
};

RatchetBracketWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    priceToBreak: PropTypes.any,
    stop: PropTypes.any,
    pendingTargets: PropTypes.array
  })
};

